import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminPartners() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/partners").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Partenaires</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />
      <div className="bg-ink-900 border border-ink-700 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-ink-800 text-zinc-400 uppercase text-xs">
            <tr><th className="text-left px-4 py-3">Société</th><th className="text-left px-4 py-3">Type</th><th className="text-left px-4 py-3">Contact</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Email</th><th className="text-left px-4 py-3">Volume</th><th className="text-left px-4 py-3">Date</th></tr>
          </thead>
          <tbody className="divide-y divide-ink-700">
            {rows.map((p) => (
              <tr key={p.id} className="hover:bg-ink-800">
                <td className="px-4 py-3 font-semibold">{p.company_name}<div className="text-xs text-zinc-500">{p.siret || ""}</div></td>
                <td className="px-4 py-3">{p.partner_type}</td>
                <td className="px-4 py-3">{p.contact_name}</td>
                <td className="px-4 py-3">{p.phone}</td>
                <td className="px-4 py-3">{p.email}</td>
                <td className="px-4 py-3">{p.monthly_volume || "—"}</td>
                <td className="px-4 py-3 text-zinc-500 text-xs">{(p.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="text-center py-8 text-zinc-500">Aucune demande de partenariat</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
